export default __webpack_public_path__ + "static/media/adding_filter.8cd3a277.gif";